// Géométrie et mise en forme des distances.
// Module pur : aucune dépendance au DOM ni à l'état de l'application, donc testable
// directement sans stub.

function haversineMeters(aLat, aLng, bLat, bLng) {
    const R = 6371000, rad = Math.PI / 180;
    const dLat = (bLat - aLat) * rad, dLng = (bLng - aLng) * rad;
    const h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(aLat * rad) * Math.cos(bLat * rad) *
              Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
}


function distanceToSegment(pLat, pLng, aLat, aLng, bLat, bLng) {
    const kx = 111320 * Math.cos(pLat * Math.PI / 180), ky = 110540;
    const px = pLng * kx, py = pLat * ky;
    const ax = aLng * kx, ay = aLat * ky;
    const bx = bLng * kx, by = bLat * ky;
    const dx = bx - ax, dy = by - ay;
    const len2 = dx * dx + dy * dy;
    let t = len2 ? ((px - ax) * dx + (py - ay) * dy) / len2 : 0;
    t = Math.max(0, Math.min(1, t));
    const cx = ax + t * dx, cy = ay + t * dy;
    return Math.sqrt((px - cx) * (px - cx) + (py - cy) * (py - cy));
}


function distanceToRoute(lat, lng, pts, cursor) {
    if (!pts || pts.length < 2) return { dist: Infinity, idx: cursor | 0 };
    const WINDOW = 150;
    const from = Math.max(0, cursor - WINDOW);
    const to = Math.min(pts.length - 1, cursor + WINDOW);
    let best = Infinity, bestIdx = cursor;
    for (let i = from; i < to; i++) {
        const d = distanceToSegment(lat, lng, pts[i][0], pts[i][1], pts[i + 1][0], pts[i + 1][1]);
        if (d < best) { best = d; bestIdx = i; }
    }
    return { dist: best, idx: bestIdx };
}


// Azimut de a vers b, en degrés depuis le nord géographique, sens horaire. C'est la
// convention attendue telle quelle par le paramètre `bearings` d'OSRM et par le `heading`
// de Valhalla — d'où le choix de cette unité plutôt que des radians.
function bearingDegrees(aLat, aLng, bLat, bLng) {
    const rad = Math.PI / 180;
    const f1 = aLat * rad, f2 = bLat * rad;
    const dl = (bLng - aLng) * rad;
    const y = Math.sin(dl) * Math.cos(f2);
    const x = Math.cos(f1) * Math.sin(f2) - Math.sin(f1) * Math.cos(f2) * Math.cos(dl);
    // atan2(0, 0) vaut 0 : deux points confondus donnent le nord, jamais NaN. L'appelant
    // reçoit un cap inutile mais valide, ce qui vaut mieux qu'une requête de routage cassée.
    return (Math.atan2(y, x) / rad + 360) % 360;
}


function roundDistance(m) {
    if (m < 20) return Math.round(m);
    if (m < 100) return Math.round(m / 5) * 5;
    if (m < 1000) return Math.round(m / 10) * 10;
    return m;
}


function formatDistance(m) {
    if (m >= 1000) return (m / 1000).toFixed(1).replace('.', ',') + ' km';
    return roundDistance(m) + ' m';
}


function spokenDistance(m) {
    if (m >= 1000) return (m / 1000).toFixed(1).replace('.', ',') + ' kilomètres';
    const r = roundDistance(m);
    return r + (r === 1 ? ' mètre' : ' mètres');
}


export {
    haversineMeters, distanceToSegment, distanceToRoute, bearingDegrees,
    roundDistance, formatDistance, spokenDistance
};
